import { Navigate } from "react-router-dom";
import {
  getCompanyCode,
  hasSession,
  isAssignedCompany,
  needsPasswordChange,
} from "./auth/authSession";

const AuthenticatedRoute = ({
  children,
  requireCompany = false,
  allowPasswordChange = false,
}) => {
  if (!hasSession()) {
    return <Navigate to="/login" replace />;
  }
  if (!allowPasswordChange && needsPasswordChange()) {
    return <Navigate to="/change-password" replace />;
  }
  if (requireCompany) {
    const company = getCompanyCode();
    if (!company || !isAssignedCompany(company)) {
      return <Navigate to="/company" replace />;
    }
  }
  return children;
};

export default AuthenticatedRoute;
